import { Component } from "react";
import { AuthorizationResponsePayload } from "@sphereon/ssi-sdk.siopv2-oid4vp-common";
import { CredentialMapper } from "@sphereon/ssi-types";

export type GenericInsuranceProps = {
  payload: AuthorizationResponsePayload;
  onApply?: () => void;
};

export type GenericInsuranceState = {
  showAuthenticationModal?: boolean;
  payload: AuthorizationResponsePayload;
};

export default class GenericInsurance extends Component<
  GenericInsuranceProps,
  GenericInsuranceState
> {
  state: GenericInsuranceState = {
    showAuthenticationModal: false,
    payload: null,
  };

  protected showLoginDialog = () => {
    if (this.props.onApply) this.props.onApply();
  };

  protected isAuthenticated(): boolean {
    let payload = this.props.payload ?? this.state.payload;
    return payload !== undefined;
  }

  protected getPayload(): AuthorizationResponsePayload {
    return this.props.payload ?? this.state.payload;
  }

  protected getSubjects(): any {
    let payload = this.props.payload ?? this.state.payload;
    if (payload) {
      const presentation = CredentialMapper.toWrappedVerifiablePresentation(
        Array.isArray(payload.vp_token)
          ? payload.vp_token[0]
          : payload.vp_token!,
      );
      const subjects =
        presentation?.presentation?.verifiableCredential[0].credential
          .credentialSubject!; // Although rare, a VC can have more than one subject
      return subjects;
    }
    return null;
  }
}
